import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PortalAuthService } from '../../core/portal-auth.service';
import { PortalStateService } from '../../core/portal-state.service';
import { WelcomeDialogComponent } from '../../core/welcome-dialog.component';
import { I18nService } from '../../core/i18n.service';
import { Lang } from '../../core/translations';

// The signed-in frame: header, customer switcher, nav. Everything inside it
// reads the same selected customer, so switching employer re-scopes the whole
// portal in one place rather than per page.
@Component({
  selector: 'portal-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.css']
})
export class ShellComponent implements OnInit {

  session: any = null;
  navOpen = false;

  constructor(
    public state: PortalStateService,
    private auth: PortalAuthService,
    private dialog: MatDialog,
    public i18n: I18nService
  ) { }

  ngOnInit() {
    this.auth.session$.subscribe(s => {
      this.session = s;
      // Most customers have exactly one kundekort, so the switcher is hidden
      // and the single customer is simply selected.
      if (s && !this.state.customerId && s.customers && s.customers.length) {
        this.state.selectCustomer(s.customers.length === 1 ? s.customers[0].customerId : null);
      }
      if (s && s.user && s.user.uid) { this.maybeShowWelcome(s.user); }
    });
  }

  // Shown once per account, the first time they sign in. Tracked in
  // localStorage rather than on the portalUsers doc — it's a courtesy nudge,
  // not a security or business fact, so nothing server-side needs to know.
  private maybeShowWelcome(user: any) {
    const key = 'portal_welcome_seen_' + user.uid;
    if (localStorage.getItem(key)) { return; }
    localStorage.setItem(key, '1');
    this.dialog.open(WelcomeDialogComponent, {
      width: '560px',
      data: { name: user.name, role: user.role, rights: user.rights }
    });
  }

  get customers(): any[] { return (this.session && this.session.customers) || []; }
  get user(): any { return (this.session && this.session.user) || {}; }

  get currentCustomerName(): string {
    if (!this.state.customerId) { return 'All companies'; }
    const c = this.customers.find(x => x.customerId === this.state.customerId);
    return c ? c.name : '';
  }

  onCustomerChange(customerId: string | null) {
    this.state.selectCustomer(customerId);
  }

  setLang(lang: Lang) { this.i18n.setLang(lang); }

  signOut() { this.auth.signOut(); }
}
